import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { MessageCircle } from "lucide-react";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { CONTACT } from "@/data/content";

import Home from "@/pages/Home";
import DiagnosticPage from "@/pages/DiagnosticPage";
import OffresPage from "@/pages/OffresPage";
import ContactPage from "@/pages/ContactPage";
import AvisPage from "@/pages/AvisPage";
import PortfolioPage from "@/pages/PortfolioPage";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const FloatingWhatsApp = () => (
  <a
    data-testid="floating-whatsapp"
    href={`https://wa.me/${CONTACT.whatsapp}`}
    target="_blank"
    rel="noreferrer"
    className="fixed bottom-6 left-6 z-40 flex items-center justify-center h-14 w-14 rounded-full bg-green-600 hover:bg-green-700 text-white shadow-lg transition-transform hover:scale-105"
    aria-label="Contacter sur WhatsApp"
  >
    <MessageCircle size={26} />
  </a>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="pt-16 lg:pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/diagnostic" element={<DiagnosticPage />} />
            <Route path="/offres" element={<OffresPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/avis" element={<AvisPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
